import { render, staticRenderFns } from "./MainDescription.vue?vue&type=template&id=6c50aed4&lang=pug"
import script from "./MainDescription.vue?vue&type=script&lang=js"
export * from "./MainDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports